<template>
    <section v-if="!isError" class="flex h-full w-full flex-col items-center justify-center">
        <LoadingAnimation :text="loadingText" :vertical="true" />
    </section>
    <section v-else class="m-4 flex h-full w-auto flex-col items-center justify-center">
        <h1>
            <i class="pi pi-times-circle text-3xl text-danger" />
            {{ errorTitle }}
        </h1>
        <slot />
    </section>
</template>

<script setup lang="ts">
    defineProps<{
        loadingText: string;
        isError: boolean;
        errorTitle?: string;
    }>();
</script>
